import { useState, FormEvent } from 'react'
import { AttachIcon, SendIcon } from '../icons/Icons'
import styles from './ChatInput.module.css'

interface ChatInputProps {
  onSend?: (message: string) => void
  onAttachClick?: () => void
  isUploading?: boolean
}

export function ChatInput({ onSend, onAttachClick, isUploading = false }: ChatInputProps) {
  const [value, setValue] = useState('')

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    if (value.trim() && onSend) {
      onSend(value.trim())
      setValue('')
    }
  }

  return (
    <div className={styles.inputArea}>
      <form className={styles.card} onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Share your experience..."
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className={styles.input}
        />
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.btn}
            onClick={onAttachClick}
            disabled={isUploading}
          >
            <AttachIcon className={styles.icon} />
          </button>
          <button type="submit" className={`${styles.btn} ${styles.primary}`}>
            <SendIcon className={styles.icon} />
          </button>
        </div>
      </form>
    </div>
  )
}
